import React, { useRef } from 'react';
import {
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  Datagrid,
} from 'react-admin';

import { makeStyles, Card } from '@material-ui/core';
import AssignmentIcon from '@material-ui/icons/Assignment';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { SECONDARY_COLOR } from '../../utils';
import { PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR } from '../../utils/dadosTelas';
import DialogoPdf from '../NfeCompras/DialogoPdf';
import CnpjField from '../NfeCompras/Fields/CnpjField';
import DataEmissaoField from '../NfeCompras/Fields/DataEmissaoField';
import ManifestacaoField from '../NfeCompras/Fields/ManifestacaoField';
import ValorField from '../NfeCompras/Fields/ValorField';
//import ActionsField from './ActionsField';
import Filter from './Filter';

const tabs = [
  { id: 'ativos', name: 'Não Concluídos' },
  { id: 'inativos', name: 'Concluídos' },
];

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    // marginLeft: '30px',
    // backgroundColor: 'blue',
    flex: 1,
    backgroundColor: SECONDARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 'bold',
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    // backgroundColor: '#f8f8f8',
    padding: '10px',
    // color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    // borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

const PostPanel = ({ record }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
    <div>
      <span
        style={{
          fontWeight: 'bold',
          marginRight: '10px',
        }}
      >
        Chave de Acesso:
      </span>
      <span>{record.chave}</span>
    </div>
    {record.justificativaManifestacao ? (
      <div>
        <span
          style={{
            fontWeight: 'bold',
            marginRight: '10px',
          }}
        >
          Justificativa:
        </span>
        <span>{record.justificativaManifestacao}</span>
      </div>
    ) : null}
  </div>
);
//
const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const classes = useStyles();
  const refDialogoPdf = useRef(null);

  function handlePDF(dados) {
    if (refDialogoPdf.current) {
      refDialogoPdf.current.handleOpen(dados.chave);
    }
  }

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <Title title="NFEs Problemáticas" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <div>
          <Datagrid {...props}>
            <TextField
              source="nsu"
              label="NSU"
              sortable={false}
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
            />
            <TextField
              source="emitRazao"
              label="Razão Social do Emitente"
              sortable={false}
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
            />
            <CnpjField
              source="emitCnpj"
              label="CNPJ do Emitente"
              sortable={false}
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
            />
            <DataEmissaoField
              source="dhEmis"
              label="Data da Emissão"
              sortable={false}
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
            />
            <ValorField
              source="vNF"
              label="Valor da NFE"
              sortable={false}
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
            />
            <ManifestacaoField
              source="tipo_manifestacao"
              label="Manifestação"
              sortable={false}
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
            />
            <ActionsField
              source="valor"
              textAlign="right"
              label="Ações"
              sortable={false}
              //handlePdf={handlePDF}
              headerClassName={classes.dataHeader}
              cellClassName={classes.dataCell}
              actions={[
                {
                  title: 'Exibir PDF',
                  icon: <AssignmentIcon />,
                  show: () => true,
                  disabled: () => false,
                  onClick: (record) => handlePDF(record),
                },
              ]}
            />
          </Datagrid>
        </div>
        <TransacoesPagination />
      </Card>
      <DialogoPdf ref={refDialogoPdf} handleClose={handleClose} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR}>
    <ContainerMyList
      {...props}
      expand={<PostPanel />}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="NFEs Problemáticas"
      component="div"
    />
  </ProtegerPagina>
);

export default List;
